import React from 'react';
import { BookOpen } from 'lucide-react';
export function LogoHeader() {
  return <header className="w-full bg-cosmic-deep py-3 md:py-4 flex justify-center items-center" data-id="element-255" data-mp="ecguc3g4b17">
      <div className="flex items-center gap-1.5" aria-label="Prodikit" data-id="element-256" data-mp="f2yvscp5v0rw">
        <span className="font-display font-black text-xl md:text-2xl tracking-tight text-white" data-id="element-257" data-mp="f51v5nc7e69a">
          PRODI
        </span>
        <span className="font-display font-black text-xl md:text-2xl tracking-tight text-[#F5A623]" data-id="element-258" data-mp="o3dinghrwnxi">
          KIT
        </span>
        <div className="ml-1 w-6 h-6 md:w-7 md:h-7 rounded-md bg-gradient-to-br from-[#F5A623] to-[#FF6B00] flex items-center justify-center shadow-md" data-id="element-259" data-mp="k10e2veriw2b">
          <BookOpen className="w-3.5 h-3.5 md:w-4 md:h-4 text-white" strokeWidth={2.5} data-id="element-260" data-mp="xzguxf6ca2y6" />
        </div>
      </div>
    </header>;
}